<div
  data-layer="View other sellers"
  class="ViewOtherSellers w-full min-h-screen relative bg-Neutrals-White overflow-hidden px-4 sm:px-6 lg:px-8"
>
  <!-- Breadcrumb -->
  <div class="breadcrumb-container py-2">
    <app-breadcrum [data]="viewOtherBreadcrumbs"></app-breadcrum>
  </div>

  <!-- Title Section -->
  <div class="title-container py-4 sm:py-6" *ngIf="products?.length > 0">
    <div class="flex justify-between items-center">
      <div class="flex flex-col gap-2">
        <h1 class="text-2xl font-bold text-Neutrals-Black">
          {{ comparisonData.title }}
        </h1>
        <p class="text-sm text-Text-Caption font-medium">
          {{ comparisonData.subtitle }}
        </p>
      </div>
      <!-- Navigation Arrows -->
      <div class="flex gap-2">
        <button
          class="w-8 h-8 bg-blue-500 rounded-lg shadow-md flex items-center justify-center"
          (click)="onPreviousPage()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M12.6008 14.7998L8.50789 10.7069C8.11736 10.3164 8.11736 9.68322 8.50789 9.2927L12.6008 5.1998"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button
          class="w-8 h-8 bg-blue-500 rounded-lg shadow-md flex items-center justify-center"
          (click)="onNextPage()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M9 6L14.2929 11.2929C14.6834 11.6834 14.6834 12.3166 14.2929 12.7071L9 18"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Product Cards Section (Horizontal Scrollable) -->

  <!-- Comparison Table Section -->
  <div class="comparison-table-section p-4">
    <!-- No Data Message -->
    <div *ngIf="!products || products?.length === 0" class="text-center py-8">
      <div class="text-gray-500 text-lg mb-2">
        No sellers found for this product
      </div>
      <div class="text-gray-400 text-sm">
        Try searching for a different product or check back later
      </div>
    </div>

    <!-- Table with Data -->
    <div
      *ngIf="products && products?.length > 0"
      class="overflow-x-auto w-full"
      #tableContainer
    >
      <table
        class="border-collapse table-fixed"
        [style.min-width]="
          products?.length > 0 ? 128 + products.length * 288 + 'px' : '416px'
        "
      >
        <tbody>
          <tr class="border-b border-gray-200">
            <td class="w-32 border-gray-200 p-3 text-center align-middle">
              <!-- <span class="text-sm font-bold text-gray-600">Price &<br/>Offers</span> -->
            </td>
            <td
              class="w-72 border-gray-200"
              *ngFor="let seller of products; let i = index"
            >
              <div class="product-cards-section p-4">
                <div class="overflow-hidden" #productCardsContainer>
                  <div class="flex gap-2 min-w-max">
                    <div class="w-72 flex-shrink-0">
                      <div
                        class="bg-white border-gray-200 rounded-lg cursor-pointer"
                        (click)="onCardClick(i)"
                      >
                        <!-- Product Image
                                [class.border-blue-500]="i === currentCardIndex"
                             [class.border-2]="i === currentCardIndex" -->
                        <div class="mb-4">
                          <img
                            [src]="seller?.part_image_path[0]"
                            [alt]="seller?.DISTRICT_s"
                            class="w-full h-48 object-cover rounded-md"
                          />
                        </div>

                        <!-- Action Buttons -->
                        <div class="flex gap-2">
                          <!-- Buy Now Button -->
                          <app-buy-now-button
                            [productData]="seller"
                            (buyNowClicked)="onBuyNow(seller)"
                            (paymentSuccess)="onPaymentSuccess($event)"
                            class="flex-1"
                          >
                          </app-buy-now-button>

                          <!-- Animated Cart Button -->
                          <button
                            *ngIf="seller?.part_number"
                            class="cart-btn flex items-center justify-center gap-1 p-2 w-full flex-1 whitespace-nowrap bg-blue-500 rounded-lg min-h-10 max-sm:h-[32px] max-sm:p-1 max-sm:gap-1 max-sm:rounded-[8px] max-sm:border max-sm:border-[0.832px] max-sm:border-[#307FE1] max-sm:bg-[#307FE1] max-sm:text-[12px]"
                            [class.added]="
                              itemAddedToCart.get(seller?.part_number!)
                            "
                            (click)="
                              itemAddedToCart.get(seller?.part_number!)
                                ? goToCartWithEvent($event)
                                : addToCart($event, seller?.part_number!)
                            "
                          >
                            <div class="cart-content cart-content-add">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="21"
                                height="20"
                                viewBox="0 0 21 20"
                                fill="none"
                                class="cart-icon-svg"
                              >
                                <rect
                                  width="20"
                                  height="20"
                                  transform="translate(0.5)"
                                  fill="none"
                                />
                                <path
                                  d="M8.8335 16.6664C9.52373 16.6664 10.0833 17.2262 10.0835 17.9164C10.0835 18.6067 9.52383 19.1664 8.8335 19.1664C8.14314 19.1664 7.5835 18.6067 7.5835 17.9164C7.58367 17.2262 8.14325 16.6664 8.8335 16.6664ZM14.6665 16.6664C15.3568 16.6664 15.9163 17.2262 15.9165 17.9164C15.9165 18.6067 15.3569 19.1664 14.6665 19.1664C13.9763 19.1662 13.4165 18.6066 13.4165 17.9164C13.4167 17.2263 13.9764 16.6665 14.6665 16.6664ZM3.27002 1.04138C4.39468 1.04138 5.36515 1.84432 5.55322 2.95447L5.79346 4.37439H17.9878C18.9333 4.37452 19.6497 5.25689 19.4136 6.18884L18.3052 10.558C18.0453 11.5821 17.116 12.2913 16.0601 12.2914H7.82471C7.57773 12.2914 7.33826 12.2503 7.11279 12.1781L7.3374 13.5062C7.4341 14.0783 7.78213 14.3741 8.22314 14.3744H16.3335L16.4595 14.3871C16.7439 14.4454 16.9582 14.6977 16.9585 14.9994C16.9585 15.3013 16.7441 15.5533 16.4595 15.6117L16.3335 15.6244H8.22314C7.03842 15.624 6.27937 14.7463 6.10498 13.7152L5.54053 10.3783L4.64893 5.10388L4.3208 3.16345C4.23669 2.66692 3.79757 2.29138 3.27002 2.29138H2.1665C1.82146 2.29123 1.5415 2.01146 1.5415 1.66638C1.54168 1.32145 1.82156 1.04154 2.1665 1.04138H3.27002ZM6.77295 10.1693C6.8569 10.6659 7.29715 11.0412 7.82471 11.0414H16.0601C16.5551 11.0413 16.9778 10.7098 17.0942 10.2504L18.2017 5.88123C18.2316 5.76161 18.1414 5.62452 17.9878 5.62439H6.00439L6.77295 10.1693Z"
                                  fill="white"
                                />
                              </svg>
                              <span
                                class="btn-text text-base font-bold text-white max-sm:text-[12px]"
                                >Add to Cart</span
                              >
                            </div>
                            <div class="cart-content cart-content-go">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                class="cart-icon-svg w-5 h-5"
                              >
                                <path
                                  d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                                  fill="white"
                                />
                              </svg>
                              <span
                                class="btn-text text-base font-bold text-white max-sm:text-[12px]"
                                >Go to Cart</span
                              >
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <!-- Price & Offers Row -->
          <tr class="border-b border-gray-200">
            <td
              class="w-32 bg-gray-50 border-l border-r border-gray-200 p-3 text-center align-middle"
            >
              <span class="text-sm font-bold text-gray-600"
                >Price &<br />Offers</span
              >
            </td>
            <td
              class="w-72 p-4 border-r border-gray-200"
              *ngFor="let seller of products; let i = index"
            >
              <div class="flex items-center gap-2 mb-2">
                <span class="text-lg font-bold"
                  >₹{{
                    seller?.discounted_price
                      ? seller?.discounted_price
                      : (seller?.price_s | number: "1.0-0")
                  }}</span
                >
                <span
                  class="text-sm text-gray-500 line-through"
                  *ngIf="seller?.discounted_price"
                  >₹{{ seller?.price_s | number: "1.0-0" }}</span
                >
                <span
                  class="px-2 py-1 bg-green-500 text-white text-xs rounded-full"
                  *ngIf="seller?.discount_percentage > 0"
                  >{{ seller?.discount_percentage }}% Off</span
                >
              </div>
              <div class="text-sm text-gray-600">
                Get it for as low as ₹{{
                  seller?.discounted_price
                    ? seller?.discounted_price
                    : (seller?.price_s | number: "1.0-0")
                }}, Extra 5% OFF today
              </div>
            </td>
          </tr>

          <!-- Seller Row -->
          <tr class="border-b border-gray-200">
            <td
              class="w-32 bg-gray-50 border-l border-r border-gray-200 p-3 text-center align-middle"
            >
              <span class="text-sm font-bold text-gray-600">Seller</span>
            </td>
            <td
              class="w-72 p-4 border-r border-gray-200"
              *ngFor="let seller of products; let i = index"
            >
              <div class="text-sm">
                {{ seller?.seller_name }}, {{ seller?.DISTRICT_s }}
              </div>
            </td>
          </tr>

          <!-- Grade Row -->
          <tr class="border-b border-gray-200">
            <td
              class="w-32 bg-gray-50 border-l border-r border-gray-200 p-3 text-center align-middle"
            >
              <span class="text-sm font-bold text-gray-600">Grade</span>
            </td>
            <td
              class="w-72 p-4 border-r border-gray-200"
              *ngFor="let seller of products; let i = index"
            >
              <div class="flex items-center gap-2">
                <div
                  class="w-6 h-6 rounded flex items-center justify-center"
                  [ngClass]="
                    seller?.quality_s === 'A'
                      ? 'bg-green-600'
                      : seller?.quality_s === 'B'
                        ? 'bg-yellow-600'
                        : seller?.quality_s === 'C'
                          ? 'bg-orange-600'
                          : 'bg-green-600'
                  "
                  *ngIf="seller?.quality_s"
                >
                  <span class="text-white text-xs font-bold">{{
                    seller?.quality_s
                  }}</span>
                </div>
                <span class="text-sm" *ngIf="seller?.quality_s"
                  >Certified {{ seller?.quality_s }}-grade, reliable &
                  tested.</span
                >
              </div>
            </td>
          </tr>

          <!-- Delivery Row -->
          <tr class="border-b border-gray-200">
            <td
              class="w-32 bg-gray-50 border-l border-r border-gray-200 p-3 text-center align-middle"
            >
              <span class="text-sm font-bold text-gray-600">Delivery</span>
            </td>
            <td
              class="w-72 p-4 border-r border-gray-200"
              *ngFor="let seller of products; let i = index"
            >
              <div class="text-sm">Get Delivery by {{ getDeliveryDate() }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Buy Now Popup -->
<app-buy-now-popup
  [productData]="selectedProductForBuyNow"
  [isOpen]="isBuyNowPopupOpen"
  [quantity]="getQuantityForPopup(selectedProductForBuyNow)"
  [unit]="selectedProductForBuyNow?.selectedUnit === 'kg' ? 'Kg' : 'Ton'"
  (close)="closeBuyNowPopup()"
>
</app-buy-now-popup>

<!-- Scrap Certificate Modal -->
<app-scrap-certificate-modal></app-scrap-certificate-modal>
